module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnRoZW1lLWRhcmsgLmdjbC1yYXRpbmcgew0KCS5vbiA+IGkgew0KCQliYWNrZ3JvdW5kLWNvbG9yOiAkZ29sZDsNCgl9DQp9DQo="


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/RatingStars/RatingStarsDark.scss
// module id = 2569
// module chunks = 0